﻿import { useLocation, useNavigate } from "react-router-dom";
import { Eye } from "lucide-react";

import styles from "./custom-product-name.module.scss";

const CustomProductName = ({ product, showName = true }) => {
	const location = useLocation();
	const navigate = useNavigate();

	const handleOpen = () => {
		const params = new URLSearchParams(location.search);
		params.set("product", product?.code);
		params.set("action", "detail");
		navigate(
			{
				pathname: location.pathname,
				search: `?${params.toString()}`,
				hash: location.hash,
			},
			{ replace: true },
		);
	};

	return (
		<div className={styles.wrapper}>
			<button type="button" className={styles.iconBtn} onClick={handleOpen} title="Ver etiqueta" aria-label="Ver etiqueta">
				<Eye size={18} aria-hidden />
			</button>

			{showName && (
				<div className={styles.productName} title={product?.label}>
					{product?.label}
				</div>
			)}
		</div>
	);
};

export default CustomProductName;
